import '@onpace/svgspritemap-rails'

/// Updates the spritemap symbol on the SVG element.
///
/// Icons starting with +flag/+ are served from the 'flags' spritemap; all others from the 'onspace' spritemap.
/// Also sets the +viewbox+ option to +0 0 20 15+ for flags and +0 0 20 20+ for all others unless already given.
SVGElement.prototype.setOnspaceSpritemapSvg = function(name, options = {}) {
  if (name && name.startsWith('flag/')) {
    options.viewbox ||= '0 0 20 15'
    options.spritemap = 'flags'
  } else {
    options.viewbox ||= '0 0 20 20'
    options.spritemap = 'onspace'
  }

  this.setSpritemapSvg(name, options)
}

/// Creates a new spritemap SVG element.
///
/// Icons starting with +flag/+ are served from the 'flags' spritemap; all others from the 'onspace' spritemap.
/// Also sets the +viewbox+ option to +0 0 20 15+ for flags and +0 0 20 20+ for all others unless already given.
SVGElement.createOnspaceSpritemapSvg = function(name, options = {}) {
  if (name && name.startsWith('flag/')) {
    options.viewbox ||= '0 0 20 15'
    options.spritemap = 'flags'
  } else {
    options.viewbox ||= '0 0 20 20'
    options.spritemap = 'onspace'
  }

  return this.createSpritemapSvg(name, options)
}
